import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from './base.service';
import { StoryItem } from '@/models/story-item.model';

class StoryItemService extends BaseService {
  private url: string = '/api/story-item';

  constructor() {
    super();
  }

  public async get(id: number): Promise<DataResponse<StoryItem>> {
    const res = await this.$http.get<StoryItem>(`${this.url}/${id}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async getList(): Promise<DataResponse<StoryItem[]>> {
    const res = await this.$http.get<StoryItem[]>(`${this.url}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async create(
    story: Partial<StoryItem>,
  ): Promise<DataResponse<StoryItem>> {
    const res = await this.$http.post<StoryItem>(this.url, story);

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
    };
  }

  public async edit(story: StoryItem): Promise<DataResponse<StoryItem>> {
    const res = await this.$http.put<StoryItem>(
      `${this.url}/${story.id}`,
      story,
    );

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async delete(storyId: number, id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(
      `${this.url}/${storyId}/${id}`,
    );

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }
}

export default new StoryItemService();
